// @ts-nocheck
document.addEventListener('alpine:init', () => {
  // AM-CUSTOM: move .social-icons__wrapper under .email-signup-block (social often lives in footer-utilities, email in main footer — both are under <footer>)
  Alpine.data('FooterSocialUnderEmail', () => ({
    init() {
      const run = () => {
        const root = this.$el;
        const email = root.querySelector('.email-signup-block');
        if (!email) return;
        root.querySelectorAll('.social-icons__wrapper').forEach((social) => {
          if (!email.contains(social)) email.appendChild(social);
        });
      };
      this.$nextTick(() => {
        run();
        requestAnimationFrame(run);
      });
    },
  }));

  Alpine.data('ProductComponent', () => ({
    product: null,
    selected_variant: null,
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      this.product = JSON.parse(this.$el.dataset.product);
      let selected_variant_id = this.$el.dataset.selected_variant_id;
      this.selected_variant = this.product.variants.find(v => v.id == selected_variant_id);
    },
    InitWatchers() {
      this.$el.addEventListener('change', (e) => {
        let variant_id = e.target.dataset.variantId;
        if (!variant_id) return;
        this.selected_variant = this.product.variants.find(v => v.id == variant_id);
        this.$el.querySelectorAll('[name="id"]').forEach(input => input.value = this.selected_variant.id);
        document.dispatchEvent(new CustomEvent('variant:changed', { detail: { 
          variant: this.selected_variant,
          variantId: this.selected_variant.id
        }}));
      });
    }
  }));

  // Registered globally so quick-add modal (fetched HTML + morph) can use x-data; inline
  // scripts in that HTML never execute, so snippet-local Alpine.data() never ran there.
  Alpine.data('InventoryCounter', () => ({
    threshold_low: 5,
    variants: [],
    current_variant: null,
    percent: 0,
    init() {
      this.variants = JSON.parse(this.$el.dataset.inventory_json).variants;
      this.current_variant = this.variants.find((item) => item.id == this.$el.dataset.current_variant_id);
      this.CheckProgress();

      // Theme variant-picker dispatches `variant:update` (bubbles); scope to section/dialog so
      // multiple products on a page do not cross-update.
      const root = this.$el.closest('.shopify-section, dialog');
      const onVariantUpdate = (e) => {
        const vid = e.detail?.resource?.id;
        if (vid == null) return;
        this.current_variant = this.variants.find((item) => String(item.id) === String(vid));
        this.CheckProgress();
      };
      root?.addEventListener('variant:update', onVariantUpdate);
      return () => root?.removeEventListener('variant:update', onVariantUpdate);
    },
    CheckProgress() {
      let percent = this.current_variant?.inventory_quantity ?? 0;
      if (percent > 100) {
        percent = 100;
      }
      this.percent = percent;
    }
  }));

  Alpine.data('SizeGuideLink', () => ({
    e_OpenSizeGuide() {
      document.querySelector('.product-details .popup-link .popup-link__button')?.click();
    }
  }));
});